"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var div = document.createElement("div");
    div.classList.add("notification", type);
    div.style.top = "".concat(posTop, "px");
    div.style.right = "".concat(posRight, "px");
    var h = document.createElement("h2");
    h.classList.add("title");
    h.textContent = title;
    var p = document.createElement("p");
    p.textContent = description;
    div.append(h, p);
    document.body.appendChild(div);
    setTimeout(function() {
        div.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.5a054f3b.js.map
